import { MailOutlined as MailOutlinedIcon } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import is from '@sindresorhus/is';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../../shared/source/context/context';
import { SecondaryActionButton } from '../../../../design/components/button/SecondaryAction';

import type { FunctionComponent, ReactNode } from 'react';

type DefaultActionItemsProps = {
    readonly userEmail?: string | undefined;
};

const DefaultActionItems: FunctionComponent<DefaultActionItemsProps> = (props) => {
    const { translate } = useContext(ApplicationContext);
    const { userEmail } = props;

    if (is.undefined(userEmail)) {
        return null;
    }

    return (
        <SecondaryActionButton
            label={translate('pages.recruiter-profile.general-information.contact')}
            startIcon={<MailOutlinedIcon />}
            onClick={() => window.open(`mailto:${userEmail}`)}
        />
    );
};

type GeneralInformationActionButtonsProps = {
    readonly actionButtons?: ReactNode;
    readonly emailAddress?: string;
    readonly hideActionButtons?: boolean;
};

export const GeneralInformationActionButtons: FunctionComponent<GeneralInformationActionButtonsProps> = ({
    actionButtons,
    emailAddress,
    hideActionButtons,
}) => {
    if (hideActionButtons === true) {
        return null;
    }

    if (!is.nonEmptyString(emailAddress) && is.undefined(actionButtons)) {
        return null;
    }

    const actionButtonsContent = actionButtons ?? <DefaultActionItems userEmail={emailAddress} />;

    return (
        <Grid container={true} gap={2} justifyContent="center" pt={3}>
            {actionButtonsContent}
        </Grid>
    );
};
